// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";


// comment
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAIZFBAQkvrCzcD_xcoJnLZ1TMGqf_HDXY",
//   authDomain: "kengmarket-ae637.firebaseapp.com",
//   databaseURL: "https://kengmarket-ae637.firebaseio.com",
//   projectId: "kengmarket-ae637",
//   storageBucket: "kengmarket-ae637.firebasestorage.app",
//   messagingSenderId: "721745953927",
//   appId: "1:721745953927:web:14a89e12ca9d7690f5a422",
//   measurementId: "G-5B2PL0GP8Z"
// };



//niceloop-dev
// const firebaseConfig = {
//   apiKey: "AIzaSyCTDPK5Qgmlf-IG7o3kqWu3uQD2B3CbGRY",
//   authDomain: "niceloop-dev.firebaseapp.com",
//   databaseURL: "https://niceloop-dev.firebaseio.com",
//   projectId: "niceloop-dev",
//   storageBucket: "niceloop-dev.firebasestorage.app",
//   messagingSenderId: "773524735811",
//   appId: "1:773524735811:web:3c7143f21f89dfee3711f6"
// };

// production
const firebaseConfig = {
  apiKey: "AIzaSyCM81ecUSYOvRAXuc-EkqSwxzPxxHsI410",
  authDomain: "niceloop.firebaseapp.com",
  databaseURL: "https://niceloop.firebaseio.com",
  projectId: "firebase-niceloop",
  storageBucket: "firebase-niceloop.appspot.com",
  messagingSenderId: "1028355006993",
  appId: "1:1028355006993:web:949cefaf3e12bb2e5007b0"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Always enable persistent multi-tab IndexedDB cache so static data + auth
// state survive offline + browser restart. Must run before any getFirestore() call.
try {
  initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
  });
} catch (err) {
  console.warn("Firestore persistent cache init failed:", err);
}

// Firestore
const db = getFirestore(app)

// Realtime Database
const rtdb = getDatabase(app)

// Storage
const storage = getStorage(app)

// Auth
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Add scopes to get email and profile info
googleProvider.addScope('email');
googleProvider.addScope('profile');

export { app, db, rtdb, storage, auth, googleProvider }